(() => {
  const sections = document.querySelectorAll('.hq-shop');

  sections.forEach((section) => {
    const addUrl = section.dataset.addUrl;
    const cartUrl = section.dataset.cartUrl || '/cart';
    const currency = section.dataset.currency || 'USD';

    let neckbandVariantId = Number(section.dataset.neckbandVariant || 0);
    let neckbandPrice = Number(section.dataset.neckbandPrice || 0);

    const urlParams = new URLSearchParams(window.location.search);
    const requestedOfferKey = urlParams.get('offer');

    const ambassadorOffers = {
      [section.dataset.benOfferKey || 'ben-greenfield']: {
        discount: Number(section.dataset.benOfferDiscount || 0),
        label: 'BEN GREENFIELD OFFER',
        name: 'Ben Greenfield'
      },
      [section.dataset.amieOfferKey || 'dr-amie']: {
        discount: Number(section.dataset.amieOfferDiscount || 0),
        label: 'DR. AMIE OFFER',
        name: 'Dr. Amie'
      }
    };

    const activeOffer = ambassadorOffers[requestedOfferKey] || null;
    const isAmbassadorOffer =
      activeOffer &&
      activeOffer.discount > 0;

    if (isAmbassadorOffer) {
      section.classList.add('is-ambassador-offer');
    }

    const displayedNeckbandPrice = () => {
      if (!isAmbassadorOffer) return neckbandPrice;

      return Math.max(0, neckbandPrice - activeOffer.discount);
    };

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2
        }).format(cents / 100).replace(/\.00$/, '');
      } catch (e) {
        return `$${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
      }
    };

    const updatePurchaseUI = () => {
      const visiblePrice = displayedNeckbandPrice();

      section.querySelectorAll('[data-base-price]').forEach((el) => {
        el.textContent = money(visiblePrice);
      });

      section.querySelectorAll('[data-selected-total]').forEach((el) => {
        el.textContent = money(visiblePrice);
      });

      section.querySelectorAll('[data-sticky-price]').forEach((el) => {
        el.textContent = money(visiblePrice);
      });

      const comparePrice = section.querySelector('[data-compare-price]');
      const ambassadorOffer = section.querySelector('[data-ambassador-offer]');
      const installmentCopy = section.querySelector('[data-installment-copy]');
      const note = section.querySelector('[data-purchase-note]');

      if (isAmbassadorOffer) {
        if (comparePrice) {
          comparePrice.textContent = money(neckbandPrice);
          comparePrice.hidden = false;
        }

        if (ambassadorOffer) {
          const offerLabel = ambassadorOffer.querySelector(
            '[data-ambassador-offer-label]'
          );
          const offerDiscountText = ambassadorOffer.querySelector(
            '[data-ambassador-offer-discount]'
          );

          if (offerLabel) {
            offerLabel.textContent = activeOffer.label;
          }

          if (offerDiscountText) {
            offerDiscountText.textContent =
              `${money(activeOffer.discount)} discount applied`;
          }

          ambassadorOffer.hidden = false;
        }

        if (installmentCopy) {
          installmentCopy.hidden = true;
        }

        if (note) {
          note.textContent =
            `${activeOffer.name} ${money(activeOffer.discount)} discount applied automatically in cart and checkout. No membership commitment required today.`;
        }
      } else {
        if (ambassadorOffer) {
          ambassadorOffer.hidden = true;
        }

        if (installmentCopy) {
          installmentCopy.hidden = false;
        }

        if (note) {
          note.textContent = 'No membership commitment required today.';
        }
      }

      const nativeVariantInput = section.querySelector(
        '[data-native-variant-input]'
      );

      if (nativeVariantInput) {
        nativeVariantInput.value = neckbandVariantId;
      }
    };

    const showError = (message) => {
      const error = section.querySelector('[data-shop-error]');

      if (!error) return;

      error.textContent = message;
      error.hidden = false;
    };

    const clearError = () => {
      const error = section.querySelector('[data-shop-error]');

      if (!error) return;

      error.hidden = true;
      error.textContent = '';
    };

    const addItems = async (items, trigger) => {
      if (!addUrl) return;

      clearError();

      const oldText = trigger ? trigger.textContent : '';

      if (trigger) {
        trigger.disabled = true;
        trigger.classList.add('is-loading');

        const label = trigger.querySelector('[data-add-label]');

        if (label) {
          label.textContent = 'Adding…';
        } else {
          trigger.textContent = 'Adding…';
        }
      }

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
              data.message ||
              'Unable to add this item.'
          );
        }

        window.location.href = cartUrl;
      } catch (error) {
        showError(
          error.message ||
            'Unable to add this item.'
        );

        if (trigger) {
          trigger.disabled = false;
          trigger.classList.remove('is-loading');

          const label = trigger.querySelector('[data-add-label]');

          if (label) {
            label.textContent = 'Add to cart';
          } else {
            trigger.textContent = oldText;
          }
        }
      }
    };


    /* ======================================================
       GALLERY
       ====================================================== */

    const mainImage = section.querySelector(
      '[data-gallery-main-image]'
    );

    const galleryThumbs = [
      ...section.querySelectorAll(
        '[data-gallery-thumb]'
      )
    ];

    const setGalleryImage = (
      index,
      options = {}
    ) => {
      if (
        !mainImage ||
        !galleryThumbs.length
      ) {
        return;
      }

      const thumb =
        galleryThumbs[index];

      if (
        !thumb ||
        !thumb.dataset.imageSrc
      ) {
        return;
      }

      galleryThumbs.forEach(
        (item, itemIndex) => {
          const active =
            itemIndex === index;

          item.classList.toggle(
            'is-active',
            active
          );

          item.setAttribute(
            'aria-current',
            active ? 'true' : 'false'
          );
        }
      );

      mainImage.src =
        thumb.dataset.imageSrc;

      mainImage.removeAttribute(
        'srcset'
      );

      if (
        options.scrollThumb !== false
      ) {
        thumb.scrollIntoView({
          behavior:
            options.instant
              ? 'auto'
              : 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    };

    galleryThumbs.forEach(
      (thumb, index) => {
        thumb.addEventListener(
          'click',
          () => {
            setGalleryImage(index);
          }
        );
      }
    );


    /* ======================================================
       PRODUCT VARIANTS
       ====================================================== */

    const variantsJSON = section.querySelector(
      '[data-product-variants]'
    );

    let variants = [];

    if (variantsJSON) {
      try {
        variants = JSON.parse(
          variantsJSON.textContent
        );
      } catch (e) {
        variants = [];
      }
    }

    const optionGroups = [
      ...section.querySelectorAll(
        '[data-product-option]'
      )
    ];

    const updateVariantFromOptions = () => {
      if (
        !variants.length ||
        !optionGroups.length
      ) {
        return;
      }

      const selectedOptions = optionGroups.map(
        (group) => {
          const active = group.querySelector(
            '.hq-shop__variant-value.is-active'
          );

          return active
            ? active.dataset.optionValue
            : null;
        }
      );

      const variant = variants.find(
        (item) => {
          return selectedOptions.every(
            (value, index) =>
              item.options[index] === value
          );
        }
      );

      if (!variant) return;

      neckbandVariantId = Number(
        variant.id
      );

      neckbandPrice = Number(
        variant.price
      );

      section.dataset.neckbandVariant =
        String(neckbandVariantId);

      section.dataset.neckbandPrice =
        String(neckbandPrice);

      const addButton = section.querySelector(
        '[data-add-main]'
      );

      if (addButton) {
        addButton.disabled =
          !variant.available;

        const label =
          addButton.querySelector(
            '[data-add-label]'
          );

        if (label) {
          label.textContent =
            variant.available
              ? 'Add to cart'
              : 'Sold out';
        }
      }

      updatePurchaseUI();
    };

    optionGroups.forEach((group) => {
      group
        .querySelectorAll(
          '[data-option-value]'
        )
        .forEach((button) => {
          button.addEventListener(
            'click',
            () => {
              group
                .querySelectorAll(
                  '[data-option-value]'
                )
                .forEach((item) => {
                  item.classList.remove(
                    'is-active'
                  );
                });

              button.classList.add(
                'is-active'
              );

              updateVariantFromOptions();
            }
          );
        });
    });


    /* ======================================================
       QUANTITY
       ====================================================== */

    const quantityInput =
      section.querySelector(
        '[data-quantity]'
      );

    const nativeQuantityInput =
      section.querySelector(
        '[data-native-quantity-input]'
      );

    const syncQuantity = () => {
      if (!quantityInput) return;

      let value = Number(
        quantityInput.value || 1
      );

      value = Math.max(
        1,
        Math.min(10, value)
      );

      quantityInput.value = value;

      if (nativeQuantityInput) {
        nativeQuantityInput.value =
          value;
      }
    };

    section
      .querySelector('[data-qty-minus]')
      ?.addEventListener(
        'click',
        () => {
          if (!quantityInput) return;

          quantityInput.value =
            Math.max(
              1,
              Number(
                quantityInput.value || 1
              ) - 1
            );

          syncQuantity();
        }
      );

    section
      .querySelector('[data-qty-plus]')
      ?.addEventListener(
        'click',
        () => {
          if (!quantityInput) return;

          quantityInput.value =
            Math.min(
              10,
              Number(
                quantityInput.value || 1
              ) + 1
            );

          syncQuantity();
        }
      );

    quantityInput?.addEventListener(
      'change',
      syncQuantity
    );


    /* ======================================================
       PRIMARY ADD TO CART
       Product-only: no monthly/annual membership line items.
       ====================================================== */

    const addMain =
      section.querySelector(
        '[data-add-main]'
      );

    addMain?.addEventListener(
      'click',
      () => {
        const quantity = Math.max(
          1,
          Number(
            quantityInput?.value || 1
          )
        );

        addItems(
          [
            {
              id: neckbandVariantId,
              quantity
            }
          ],
          addMain
        );
      }
    );


    /* ======================================================
       CLOSING CTA
       ====================================================== */

    section
      .querySelectorAll(
        '[data-scroll-to-buy]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            section
              .querySelector(
                '.hq-shop__purchase'
              )
              ?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
          }
        );
      });


    /* ======================================================
       STICKY BAR
       ====================================================== */

    const sticky =
      section.querySelector(
        '[data-sticky-buy]'
      );

    const purchase =
      section.querySelector(
        '.hq-shop__purchase'
      );

    if (
      sticky &&
      purchase &&
      'IntersectionObserver' in window
    ) {
      const observer =
        new IntersectionObserver(
          ([entry]) => {
            const visible =
              !entry.isIntersecting &&
              entry.boundingClientRect.top < 0;

            sticky.classList.toggle(
              'is-visible',
              visible
            );

            sticky.setAttribute(
              'aria-hidden',
              visible
                ? 'false'
                : 'true'
            );
          },
          {
            threshold: 0.08
          }
        );

      observer.observe(
        purchase
      );
    }

    section
      .querySelector(
        '[data-sticky-add]'
      )
      ?.addEventListener(
        'click',
        () => {
          addMain?.click();
        }
      );


    /* ======================================================
       INITIAL
       ====================================================== */

    syncQuantity();
    updatePurchaseUI();
  });
})();